// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';
import { classicFormat, percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import AgeGenderChart from '@/components/composite/Charts/composed/AgeGenderChart';

export const reachedAudienceDemographicsDistributionConfig = {
    title: 'chart.instagram.reached_audience_demographics',
    margin: {
        right: 20,
        left: -20
    },
    name: {
        age: 'age',
        female: 'female',
        male: 'male',
        percentage_male: 'percentage_male',
        percentage_female: 'percentage_female'
    },
    datePickerDoesNotApply: true,
    id: 'reached_audience_demographics_distribution',
    social: INSTAGRAM,
    color: {
        female: 'purple',
        male: 'red'
    },
    valueFormat: {
        ...classicFormat,
        signDisplay: 'never'
    },
    tooltipValueTranslation: 'chart.instagram.reached_audience_demographics_tooltip_translation',
    pieTooltipTranslation: {
        token: 'chart.instagram.reached_audience_demographics_tooltip_pie_translation',
        values: ['gender', 'value', 'percentage']
    },
    orientation: 'vertical',
    pieValueFormat: percentFormat,
    tooltip: 'chart.instagram.reached_audience_demographics_tooltip',
    size: SIZE_FULL,
    type: 'chart',
    element: AgeGenderChart
};
